module.exports = __webpack_public_path__ + "c10f26ded30f7f3e441cfae4ee2d0fb4.svg";